import { useNavigate, useOutletContext } from 'react-router-dom';
import { CarForm } from '../CarForm';
import { dataManager } from '../../lib/dataManager';

export function CarEditPage() {
    const navigate = useNavigate();
    const context = useOutletContext<any>() || {};
    const {
        selectedCar,
        loadCarBySlug,
        setIsImportOpen,
        handleDeleteAllExpenses
    } = context;

    if (!selectedCar) {
        return null;
    }

    return (
        <div className="min-h-screen bg-gray-50 pt-14 text-gray-900 font-primary">
            <CarForm
                onBack={() => navigate(-1)}
                onCarSaved={async (car) => {
                    await loadCarBySlug(car.slug);
                    navigate(-1);
                }}
                onCarDeleted={() => {
                    dataManager.invalidateCars();
                    navigate('/admin');
                }}
                editingCar={selectedCar}
                onImportClick={() => setIsImportOpen(true)}
                onDeleteAllClick={handleDeleteAllExpenses}
            />
        </div>
    );
}
